module.exports = __webpack_public_path__ + "static/media/bestof_2.d5ab1853.jpg";